<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<mat-form-field
	[appearance]="isHuge ? 'outline' : 'fill'"
	[ngClass]="{ disabled: disabled || isDisabled }"
>
	@if (!isHuge) {
		<mat-label>{{ label }}</mat-label>
	}

	<mat-select
		panelClass="globalictcc-dropdown-panel"
		[globalictccSearchInSelect]="allowSearch() || paginated"
		[paginatedMode]="paginated"
		[(options)]="options"
		(paginatedSearchChange)="onPaginatedSearch($event)"
		[value]="selection"
		[multiple]="multi"
		[disabled]="disabled || isDisabled"
		[hideSingleSelectionIndicator]="true"
		(selectionChange)="onSelectionChange($event.value)"
		(valueChange)="onValueChange($event)"
		(openedChange)="onOpenedChange($event)"
	>
		@if (multi) {
			<mat-select-trigger>
				@if (
					!selection ||
					(!paginated && (allSelected || options.length === selection.length)) ||
					(paginated && paginatedAllSelected && excludedCount === 0)
				) {
					<span>ALL</span>
				} @else if (paginated && paginatedAllSelected && excludedCount > 0) {
					<span>ALL ({{ excludedCount }} excluded)</span>
				} @else if (selection && selection.length > 1) {
					<span>
						{{ selection[0] }} (+{{ selection.length - 1 }}
						{{ selection.length === 2 ? "other" : "others" }})
					</span>
				} @else {
					<span>{{ selection[0] }}</span>
				}
			</mat-select-trigger>
		}

		@if (!options.length) {
			<mat-option
				class="select-all"
				[disabled]="true"
			>
				No options
			</mat-option>
		}

		@if (options.length && (multi || isALLOptionVisible)) {
			@if (paginated && showSelectAllControls) {
				<div
					class="select-all-shortcut"
					role="checkbox"
					tabindex="0"
					[attr.aria-checked]="paginatedAllSelected && excludedCount === 0"
					(click)="onToggleSelectAll($event)"
					(keydown.enter)="onToggleSelectAll($event)"
					(keydown.space)="onToggleSelectAll($event)"
				>
					<span class="select-all-shortcut-label">Select All</span>
					<span
						class="select-all-shortcut-checkbox"
						[class.checked]="paginatedAllSelected && excludedCount === 0"
					></span>
				</div>
			} @else {
				<mat-option
					[value]="multi ? 'all' : null"
					class="select-all"
				>
					All
				</mat-option>
			}
		}

		@for (option of options; track $index) {
			<mat-option [value]="option.value">{{ option.label }}</mat-option>
		}

		@if (paginated && (hasMore || isLoadingMore)) {
			<div
				#loadMoreSentinel
				class="load-more-option"
			>
				<span class="load-more-label">
					@if (isLoadingMore) {
						Loading…
					} @else {
						Scroll for more
					}
				</span>
			</div>
		}
	</mat-select>

	@if (isInvalid) {
		<mat-hint>Invalid input</mat-hint>
	}
</mat-form-field>
